const hasValue = (value) => value != null && value !== '';

export const getParentFeeAmount = (enquiry) =>
  hasValue(enquiry?.feeToParent) ? enquiry.feeToParent : enquiry?.feeAmount || '';

export const getParentFeeType = (enquiry) =>
  hasValue(enquiry?.feeTypeForParent) ? enquiry.feeTypeForParent : enquiry?.feeType || '';

export const getTutorFeeAmount = (enquiry) =>
  hasValue(enquiry?.feeToTutor) ? enquiry.feeToTutor : enquiry?.feeAmount || '';

export const getTutorFeeType = (enquiry) =>
  hasValue(enquiry?.feeTypeForTutor) ? enquiry.feeTypeForTutor : enquiry?.feeType || '';

export const getCompanyFeeAmount = (enquiry) => {
  if (hasValue(enquiry?.feeToCompany)) return enquiry.feeToCompany;
  const parent = getParentFeeAmount(enquiry);
  const tutor = getTutorFeeAmount(enquiry);
  if (!hasValue(parent) || !hasValue(tutor)) return '';
  const diff = Number(parent) - Number(tutor);
  return Number.isNaN(diff) ? '' : String(diff);
};
